export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "Guest reviews",
    subtitle: "Ask for a review on WhatsApp on check-out day. Set the link where you'd like guests to leave their feedback.",
    bulkNotice: "This change will apply to all {count} accommodations linked to this listing.",
    enableTitle: "Enable guest reviews",
    enableSub: "A WhatsApp message is sent automatically on check-out day asking for a review.",
    modeSingleTitle: "A single link",
    modeSingleSub: "The same for every booking",
    modePerOtaTitle: "One link per OTA",
    modePerOtaSub: "Based on the booking channel",
    linkLabel: "Review link",
    singleUrlPlaceholder: "https://g.page/r/… or the link to your reviews page",
    otaNamePlaceholder: "Site name",
    otaUrlPlaceholder: "https://… review link",
    removeTitle: "Remove",
    addOta: "Add another site",
    saving: "Saving…",
    saveConfig: "Save settings",
    note: "Guests will receive the matching link based on how they booked.",
    toastLoadError: "Couldn't load the listing data.",
    urlErrorProtocol: "The URL must start with http:// or https://",
    urlErrorInvalid: "Enter a valid URL (e.g. https://g.page/...)",
    toastStateUpdated: "Status updated successfully",
    toastStateError: "Something went wrong updating the status",
    toastUrlRequired: "Enter a URL before saving",
    toastSaved: "Settings saved successfully",
    toastSaveError: "Something went wrong while saving",
  },

  // AccessSummary.vue
  access: {
    tag: "Locks & access",
    dynamicTitle: "Smart lock connected",
    dynamicDetail: "Each booking generates a new code automatically and sends it to the guest.",
    chipCheckin: "Sent when check-in is completed",
    chipTime: "Sent at {time} on the arrival day",
    chipManual: "You send it manually",
    staticTitle: "Lock with a fixed code",
    staticDetail: "The guest receives the lockbox or lock code to get in.",
    noneTitle: "I hand over the keys in person",
    noneDetail: "You arrange the key handover with the guest on arrival.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "Update price",
    saving: "Saving…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "Link each unit of this listing to its Mossos establishment (each unit can have its own police ID). Check-ins are sent automatically to the correct establishment based on the booking's unit.",
    wholeListing: "Whole listing",
    wholeListingDefault: "Whole listing (default)",
    unitNumber: "Unit #{id}",
    badgeSendError: "Send error",
    badgeConnected: "Connected",
    badgeNoCredentials: "No credentials",
    emptyList: "No connections yet. Add one for each unit of the listing.",
    addConnection: "Add connection",
    editConnection: "Edit connection",
    newConnection: "New connection",
    unit: "Unit",
    unitPlaceholder: "Choose the unit",
    unitHint: "Which unit of the listing this establishment belongs to.",
    step1Title: "Access to the Mossos website",
    usuariLabel: "Usuari (Mossos website)",
    savedHint: "saved",
    usuariPlaceholderKeep: "Leave blank to keep unchanged",
    usuariPlaceholderNew: "Website login username",
    passLabel: "Paraula de pas",
    passBlankHint: "blank to keep unchanged",
    passPlaceholder: "Mossos website password",
    validateHint: "Validate to fetch the establishments in your account.",
    searching: "Searching…",
    validateSearch: "Validate and find establishments",
    step2Title: "Establishment for this unit",
    establishmentPlaceholder: "Select the establishment",
    revalidateHint: "Validate again to change it.",
    validateAbove: "Validate above to choose the establishment for this unit.",
    checkinTime: "Billing time (arrival)",
    checkoutTime: "Departure time",
    cancel: "Cancel",
    savingBtn: "Saving...",
    updateConnection: "Update connection",
    saveConnection: "Save connection",
    warnCredentials: "Enter the usuari and paraula de pas for the Mossos website.",
    foundEstablishments: "Found {count} establishment(s). Choose the one for this unit.",
    noEstablishments: "No establishments found in this account.",
    connectError: "Couldn't connect to Mossos. Check your usuari and password.",
    validateFirst: "Validate and choose the establishment for this connection.",
    savedOk: "Mossos connection saved.",
    saveError: "Couldn't save the connection.",
    saveErrorGeneric: "Error saving the Mossos connection.",
    confirmDelete: `Delete the connection for "{unit}" ({id})?`,
    deletedOk: "Connection deleted.",
    deleteError: "Couldn't delete the connection.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "Each unit reports its guests through a SES Hospedajes account. You can use a single account for the whole listing or set a different one for some units, for example when each apartment has its own establishment code.",
    defaultName: "Establishment {code}",
    badgeConnected: "Connected",
    badgeError: "Validation error",
    badgePending: "Not validated",
    user: "User",
    lessor: "Landlord",
    establishment: "Establishment",
    appliesWhole: "Whole listing:",
    appliesUnits: "Units:",
    noUnits: "No unit uses it",
    allUnits: "All units ({count})",
    moreUnits: "+{count} more",
    andMore: "and {count} more",
    emptyList: "You haven't connected a SES Hospedajes account yet.",
    withoutAccountTitle: "No account:",
    withoutAccountText: "Their check-ins are not reported to SES Hospedajes.",
    addAccount: "Add account",
    edit: "Edit",
    remove: "Remove",
    newTitle: "New SES Hospedajes account",
    editTitle: "Edit SES Hospedajes account",
    aliasLabel: "Account name (optional)",
    aliasPlaceholder: "E.g. Penthouses, Apartment 2B",
    aliasHint: "Only used to recognise it here. If left empty, it is shown by its establishment code.",
    loginTitle: "Ministry login",
    loginSame: "Same user and password",
    loginSameHint: "You only enter this account's codes.",
    loginOwn: "Another user and password",
    loginFrom: "Take the login from",
    passwordKeep: "Leave empty to keep it",
    passwordNeeded: "Enter the new user's password.",
    passwordShared: "{count} other account(s) in this listing use this user: changing the password updates it in all of them.",
    scopeTitle: "Which units does it apply to?",
    scopeWhole: "Whole listing",
    scopeWholeHint: "Used by the units that have no other account.",
    scopeWholeTaken: "“{name}” already is.",
    scopeUnits: "Only some units",
    scopeUnitsHint: "You choose which.",
    unitNow: "now: {name}",
    unitNowWhole: "now: the whole-listing account",
    unitNowNone: "no account",
    leftWithout: "no account after saving. Their check-ins will stop being reported to SES Hospedajes.",
    leftToWhole: "after saving, reporting goes through the whole-listing account “{name}”.",
    errUnits: "Choose at least one unit.",
    errDefaultExists: "This listing already has an account for all its units.",
    errDuplicate: "You already have that account in this listing. Edit it and add units.",
    errCopyFrom: "Couldn't take the login from that account. Enter it manually.",
    savedValidated: "Account saved and validated by the Ministry.",
    savedNotValidated: "Saved, but the Ministry rejected the details. Check them.",
    savedUnchecked: "Account saved. TRA can't verify the token in advance: you'll know on the first submission.",
    passwordSynced: "Password also updated in {count} account(s) with the same user.",
    removeTitle: "Remove this account?",
    removeNoUnits: "The account “{name}” will be removed. No unit is using it.",
    removeToFallback: "“{name}” will be removed. The units using it ({units}) will report through the whole-listing account “{fallback}”.",
    removeToNothing: "“{name}” will be removed. The units using it ({units}) will have no account and their check-ins will stop being reported to SES Hospedajes.",
    removeConfirm: "Yes, remove",
    removed: "Account removed.",
    removeError: "Couldn't remove the account.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "Loading accounts…",
    saving: "Saving…",
    close: "Close",
    show: "Show",
    hide: "Hide",

    badgeConnected: "Connected",
    badgeError: "Validation error",
    badgePending: "Not validated",
    badgeOnSend: "Checked when sending",

    edit: "Edit",
    remove: "Remove",
    addAccount: "Add account",

    appliesWhole: "Whole listing:",
    appliesUnits: "Units:",
    noUnits: "No unit uses it",
    allUnits: "All units ({count})",
    moreUnits: "+{count} more",
    andMore: "and {count} more",
    withoutAccountTitle: "No account:",

    scopeTitle: "Which units does it apply to?",
    scopeWhole: "Whole listing",
    scopeWholeHint: "Used by the units that have no other account.",
    scopeWholeTaken: "“{name}” already is.",
    scopeUnits: "Only some units",
    scopeUnitsHint: "You choose which.",
    unitNow: "now: {name}",
    unitNowWhole: "now: the whole-listing account",
    unitNowNone: "no account",
    leftToWhole: "after saving, reporting goes through the whole-listing account “{name}”.",

    aliasLabel: "Account name (optional)",
    aliasPlaceholder: "E.g. North tower, Apartment 301",
    loginFrom: "Take the login from",
    secretKeep: "Leave empty to keep it",

    errUnits: "Choose at least one unit.",
    errDefaultExists: "This listing already has an account for all its units.",
    errDuplicate: "You already have that account in this listing. Edit it and add units.",
    errCopyFrom: "Couldn't take the login from that account. Enter it manually.",
    errNoListing: "We couldn't find the listing. Open the screen again.",
    saveError: "Couldn't save the account.",

    removeTitle: "Remove this account?",
    removeConfirm: "Yes, remove",
    removeNoUnits: "The account “{name}” will be removed. No unit is using it.",
    removeToFallback: "“{name}” will be removed. The units using it ({units}) will report through the whole-listing account “{fallback}”.",
    removeToNothing: "“{name}” will be removed. The units using it ({units}) will have no account and will stop reporting to {authority}.",
    removed: "Account removed.",
    removeError: "Couldn't remove the account.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "Each unit reports its guests to SIRE through an account. You can use a single account for the whole listing or set a different one for some units, for example when each apartment is registered with its own establishment code.",
      introSingle: "Connect the account this listing uses to report its guests to SIRE.",
      emptyList: "You haven't connected a SIRE account yet.",
      withoutAccountText: "Their check-ins are not reported to SIRE.",
      newTitle: "New SIRE account",
      editTitle: "Edit SIRE account",
      modalSub: "These are the details you log in to SIRE with",
      defaultName: "Establishment {code}",
      defaultNameDoc: "Document {document}",
      docTypeLabel: "Document type",
      docType_CO_ID: "Citizen ID card (cédula de ciudadanía)",
      docType_CO_FID: "Foreigner ID card (cédula de extranjería)",
      documentLabel: "Document number",
      documentPlaceholder: "E.g. 1012345678",
      documentHint: "It's the user you log in to SIRE with.",
      passwordLabel: "Password",
      passwordPlaceholder: "Your SIRE password",
      passwordShared: "{count} other account(s) in this listing use this document: changing the password updates it in all of them.",
      estLabel: "Establishment code (optional)",
      estPlaceholder: "E.g. 67890",
      estHint: "Only needed if you report several properties with the same login. If left empty, the one you have registered is used.",
      loginTitle: "SIRE login",
      loginSame: "Same document and password",
      loginSameHint: "You only enter this account's code.",
      loginOwn: "Another document and password",
      aliasHint: "Only used to recognise it here. If left empty, it is shown by its establishment code.",
      metaDoc: "Document",
      metaEst: "Establishment",
      leftWithout: "no account after saving. Their check-ins will stop being reported to SIRE.",
      errDocument: "Enter the document number.",
      errPassword: "Enter your SIRE password.",
      errPasswordNeeded: "Enter the new document's password.",
      savedValidated: "Account saved and validated by SIRE.",
      savedNotValidated: "Saved, but SIRE rejected the details. Check them.",
      savedUnchecked: "Account saved. TRA can't verify the token in advance: you'll know on the first submission.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "Each unit sends its report to TRA through an account. You can use a single account for the whole listing or set a different one for some units: each RNT identifies one property.",
      introSingle: "Connect the account this listing uses to send its report to TRA.",
      emptyList: "You haven't connected a TRA account yet.",
      withoutAccountText: "Their stays are not reported to TRA.",
      newTitle: "New TRA account",
      editTitle: "Edit TRA account",
      modalSub: "These are this property's token and RNT",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "Paste your token here",
      tokenHint: "You generate it at",
      loginTitle: "TRA login",
      loginSame: "Same token",
      loginSameHint: "You only enter this account's RNT.",
      loginOwn: "Another token",
      rntLabel: "RNT",
      rntPlaceholder: "E.g. 123456",
      rntHint: "This property's Registro Nacional de Turismo. It's what identifies the establishment to TRA.",
      aliasHint: "Only used to recognise it here. If left empty, it is shown by its RNT.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "no account after saving. Their stays will stop being reported to TRA.",
      errToken: "Paste the TRA token.",
      errRnt: "The RNT is a number. Check it.",
      savedValidated: "Account saved and validated by TRA.",
      savedNotValidated: "Saved, but TRA rejected the details. Check them.",
      savedUnchecked: "Account saved. TRA can't verify the token in advance: you'll know on the first submission.",
    },

    foreign: {
      ses: "SES Hospedajes (Spain)",
      colombia: "SIRE and TRA (Colombia)",
      title: "There are still {name} accounts",
      text: "This listing is no longer in that country, so that account reports nothing. | This listing is no longer in that country, so those {count} accounts report nothing.",
      remove: "Remove them",
      removeTitle: "Remove the leftover accounts?",
      removeMessage: "The leftover {name} account will be removed. It doesn't affect the authority you use now. | The {count} leftover {name} accounts will be removed. It doesn't affect the authority you use now.",
      removed: "Accounts removed.",
      removeError: "Couldn't remove them.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "Check-out message",
    subtitle: "A check-out reminder sent the evening before departure. Write your own text and use the available variables.",
    loading: "Loading…",
    enableTitle: "Send check-out message",
    enableSub: "It will be sent automatically {day} at {time}.",
    dayLast: "on the departure day",
    dayBefore: "the day before departure",
    cloneTitleNoun: "check-out message",
    cloneItemNoun: "the check-out message",
    whenLabel: "When it's sent",
    dayBeforeShort: "Day before",
    dayLastShort: "Departure day",
    atLabel: "At",
    timeHint: "On the departure day the time can't be later than check-out ({time}).",
    otaTitle: "Send via OTA too",
    textLabel: "Check-out message text",
    translate: "Translate",
    translating: "Translating…",
    attach: "Attach",
    uploading: "Uploading…",
    attachTitle: "Check-out message attachments",
    emojis: "Emojis",
    searchEmoji: "Search emoji…",
    variables: "Variables",
    varsHint: "Tap to insert them. They're replaced with the booking's real data when sent.",
    uploadDone: "Sent. Saving it on the server…",
    attachLimits: "Images and PDF up to {file} MB · MP4 videos up to {video} MB.",
    attachLimitsWhy: "These are the limits WhatsApp allows.",
    tipBefore: "Use",
    tipTextWord: "text",
    tipMid: "to make something",
    tipBoldWord: "bold",
    tipAfter: "(WhatsApp formatting). The guest receives the message in their language if configured.",
    attachShared: "Attachments · shared across all languages",
    delete: "Delete",
    autosaveNote: "Changes are saved automatically.",
    preview: "Preview",
    online: "online",
    previewHint: "Updates with your settings",
    dayOfCheckout: "Departure day",
    eveOfCheckout: "Eve of departure",
    yourAccommodation: "your accommodation",
    uploadSent: "{sent} of {total} MB",
    filesCount: "{count} files",
    placeholder: "e.g. Hi {guest} 👋 Your stay at {property} ends tomorrow. Check-out time is {time}. Thanks for your visit!",
    varGuestName: "Guest name",
    varPropertyName: "Accommodation name",
    varCheckoutTime: "Check-out time",
    today: "today",
    tomorrow: "tomorrow",
    previewDefault: "Hi, *{guest}* 👋\n\nJust a reminder that your stay at *{property}* ends {when}.\n\n🕚 The latest check-out time is *{time}*.\n\nThank you so much for your stay. Safe travels! 😊",
    errVideoFormat: "❌ {name} is a {ext} video and WhatsApp only supports MP4. Convert it to MP4 and upload it again.",
    errFileSize: "❌ {name} is {size} MB and the maximum is {max} MB. ",
    errFileSizeVideo: "WhatsApp doesn't support larger videos: compress or trim it.",
    errFileSizeFile: "WhatsApp doesn't support larger files.",
    attachUploaded: "Attachment(s) uploaded successfully",
    attachUploadError: "Error uploading attachments",
    attachDeleted: "Attachment deleted",
    attachDeleteError: "Couldn't delete the attachment",
    loadError: "Couldn't load the check-out message.",
    translateEmpty: "Write the message in the active language before translating.",
    translateSuccess: "{count} languages translated! Check each tab.",
    translatePartial: "{ok} translated, {fail} failed.",
    translateError: "Couldn't translate. Please try again.",
    saved: "Check-out message saved",
    saveError: "Couldn't save the check-out message.",
  },
};
